export enum Companies {
	CASHEA = 'Cashea',
	FASTA_UNIVERSITY = 'FASTA University',
	INTIVE = 'intive',
	KLIO = 'klio',
	QUADION_TECHNOLOGIES = 'Quadion Technologies'
}
